import { render } from "./inventariogeneralhote.vue?vue&type=template&id=11c6c5dc&scoped=true"
import script from "./inventariogeneralhote.vue?vue&type=script&lang=js"
export * from "./inventariogeneralhote.vue?vue&type=script&lang=js"

import "./inventariogeneralhote.vue?vue&type=style&index=0&id=11c6c5dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c6c5dc"]])

export default __exports__